document.querySelectorAll('.slideContainer .boxBlock').forEach((boxs) => {
  if (boxs) {
    const box = boxs.querySelectorAll('.item')
    boxs.classList.remove('detail-two', 'detail-three', 'detail-four');
    if (box.length >= 4) {
      boxs.classList.add('detail-four');
    } else if (box.length >= 3) {
      boxs.classList.add('detail-three');
    } else if (box.length >= 2) {
      boxs.classList.add('detail-two');
    }
  }
});